import { render, staticRenderFns } from "./ReportYandexTasks.vue?vue&type=template&id=52130ce4&"
import script from "./ReportYandexTasks.vue?vue&type=script&lang=js&"
export * from "./ReportYandexTasks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QItem,QTable} from 'quasar'
component.options.components = Object.assign({QItem,QTable}, component.options.components || {})
